import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TimezoneService } from '../services/timezone.service';

@Injectable({
  providedIn: 'root',
})
export class NotetakingService {
  constructor(
    private http: HttpClient,
    private timezoneService: TimezoneService,
  ) {}

  getMeetingMetrics(data: any): Observable<any> {
    let params: string = '';

    Object.keys(data).forEach((key, index) => {
      const value = data[key];
      if (value !== null && value !== undefined) {
        params += `${index === 0 ? '?' : '&'}${key}=${value}`;
      }
    });

    return this.http.get('/getMeetingMetrics' + params);
  }

  getMeetingMetricsLineChart(data: any): Observable<any> {
    const timezone = this.timezoneService.getTimezone();

    data = { ...data, timezone };

    let params: string = '';

    Object.keys(data).forEach((key, index) => {
      const value = data[key];
      if (value !== null && value !== undefined) {
        params += `${index === 0 ? '?' : '&'}${key}=${value}`;
      }
    });

    return this.http.get('/getMeetingMetricsLineChart' + params);
  }

  getClientMeetingsFromMetrics(data: any): Observable<any> {
    let params: string = '';

    Object.keys(data).forEach((key, index) => {
      const value = data[key];
      if (value !== null && value !== undefined) {
        params += `${index === 0 ? '?' : '&'}${key}=${value}`;
      }
    });

    return this.http.get('/getClientMeetingsFromMetrics' + params);
  }

  getMetricFromSelectLinechartMeeting(data: any): Observable<any> {
    let params: string = '';

    Object.keys(data).forEach((key, index) => {
      const value = data[key];
      if (value !== null && value !== undefined) {
        params += `${index === 0 ? '?' : '&'}${key}=${value}`;
      }
    });

    return this.http.get('/getMetricFromSelectLinechartMeeting' + params);
  }

  getAverageMetrics(data: any): Observable<any> {
    let params: string = '';

    Object.keys(data).forEach((key, index) => {
      const value = data[key];
      if (value !== null && value !== undefined) {
        params += `${index === 0 ? '?' : '&'}${key}=${value}`;
      }
    });

    return this.http.get('/getAverageMetrics' + params);
  }

  getEmployeeAccounts(data: any): Observable<any> {
    let params: string = '';

    Object.keys(data).forEach((key, index) => {
      const value = data[key];
      if (value !== null && value !== undefined) {
        params += `${index === 0 ? '?' : '&'}${key}=${value}`;
      }
    });

    return this.http.get('/getEmployeeAccounts' + params);
  }

  createEmployee(data: any): Observable<any> {
    // query param email, type(cs, sales)
    let params: string = '';

    Object.keys(data).forEach((key, index) => {
      const value = data[key];
      if (value !== null && value !== undefined) {
        params += `${index === 0 ? '?' : '&'}${key}=${value}`;
      }
    });

    return this.http.post('/createEmployee' + params, {});
  }

  deleteEmployee(data: any): Observable<any> {
    // query param: email

    let params: string = '';

    Object.keys(data).forEach((key, index) => {
      const value = data[key];
      if (value !== null && value !== undefined) {
        params += `${index === 0 ? '?' : '&'}${key}=${value}`;
      }
    });

    return this.http.delete('/deleteEmployee' + params);
  }

  getClientEmployeeList(): Observable<any> {
    return this.http.get('/getClient-Employee-list');
  }

  filterClientsUsers(data: any): Observable<any> {
    return this.http.post('/filterClientsUsers', data);
  }

  beginConversation(data: any): Observable<any> {
    return this.http.post('/beginConversation', data);
  }

  getThreads(): Observable<any> {
    return this.http.get('/getThreads');
  }

  getThread(threadId: string): Observable<any> {
    return this.http.get(`/getThread/${threadId}`);
  }

  sendMessage(data: any): Observable<any> {
    return this.http.post(`/sendMessage`, data);
  }

  deleteAIChat(data: any): Observable<any> {
    return this.http.delete('/deleteThread', {
      body: data,
    });
  }
}
